<template>
  <div>

    <span
        class="btn btn-secondary float-right"
        @click="showCreateModal"
        qid="measures-category-create-button"
    >
      <font-awesome-icon icon="plus-circle"/>
      {{ $t('system.create_new') }}
    </span>


    <!-- Create measure category -->
    <b-modal ref="create-category" hide-footer>
      <div class="d-block text-center">
        <h4 qid="update-p-title">
          {{ $t('maintenance.measure_categories.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="createFormSubmit" qid="edit-p-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-p-name-label">
              {{ $t('maintenance.measure_categories.create.name_label') }}
            </label>
            <span class="text-red">*</span>
            <b-form-input
              qid="edit-p-form-name"
              type="text"
              v-model="pForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.measure_categories.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-p-description-label">
              {{ $t('maintenance.measures.create.description_label') }}
            </label>
            <b-form-textarea
              qid="create-p-form-description"
              v-model="pForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.measures.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group>
            <label qid="edit-p-implementation-status-label">
              {{ $t('maintenance.measure_categories.create.scope_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="selectedScopes"
                :options="scopes"
                :multiple="true"
                track-by="value"
                :taggable="true"
                :placeholder="$t('maintenance.measure_categories.create.scope_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="edit-p-form-implementation-status"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateModal"
                    qid="edit-p-cancel-button"
          >
            {{ $t('maintenance.measures.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.measure_categories.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'MeasureCategoryCreateForm',
    data: function() {
      return {
        pForm: {
          name: '',
          description: '',
          scope: []
        },
        error: '',
        selectedSort: '',
        selectedDirection: '',
        filterOpened: false,
        keywordValue: '',
        filters: {
          scope: '',
          keywordValue: ''
        },
        categoryItems: [],
        categoryInput: '',
        scopes: [
          { name: this.$t('projects.scope.activity'), value: 'activity' },
          { name: this.$t('projects.scope.system'), value: 'system' },
          { name: this.$t('projects.scope.third_party'), value: 'third_party' },
          { name: this.$t('projects.scope.assessment'), value: 'assessment' },
        ],
        loading: true,
        buttonDisabled: false,
        myGuides: [],
        selectedCategory: {},
        selectedScopes: []
      }
    },
    props: {

    },
    components: {
      Avatar
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      }
    },
    methods: {
      showCreateModal() {
        this.pForm.name = ''
        this.pForm.description = ''
        this.pForm.scope = []
        this.selectedScopes = []
        this.error = ''
        this.$refs['create-category'].show()
      },
      hideCreateModal() {
        this.pForm.name = ''
        this.pForm.description = ''
        this.pForm.scope = []
        this.$refs['create-category'].hide()
      },
      createFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        let scopes = []

        // Append list of types
        if (this.selectedScopes && this.selectedScopes.length) {
          for (var i = 0; i < this.selectedScopes.length; i++) {
            scopes.push(this.selectedScopes[i].value)
          }
        }

        this.pForm.client = this.getClient.slug;
        this.pForm.scope = scopes

        if (this.pForm.scope.length) {
          piincHttp.post('measure-categories', this.pForm).then(function(response) {
            self.hideCreateModal();
            self.$emit('reloadContent', response.data);
            self.buttonDisabled = false;
            self.$toastr('success', self.$t('maintenance.measure_categories.create.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.buttonDisabled = false;
          this.error = this.$t('system.scope_error_message')
        }
      },
    },
    created () {
      if (this.getClient && this.getClient.slug) {

      }
    }
  }
</script>
